<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div"><span style="color: red">*</span>备案企业</div>
          <el-select
            v-model="page.tenantGuid"
            placeholder="请选择备案企业"
            class="ipt-sty"
            @change="tenantChange"
            filterable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div"><span style="color: red">*</span>月份</div>
          <el-select
            v-model="monthType"
            size="mini"
            placeholder="请选择"
            class="w82"
            @change="accountMonthChange"
            filterable
          >
            <el-option
              v-for="item in monthList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-date-picker
            v-model="page.accountMonth"
            class="ipt-sty"
            size="mini"
            type="month"
            :clearable="false"
            value-format="yyyy-MM"
            placeholder="请选择核算月份"
            @change="accountMonthChange"
          >
          </el-date-picker>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">姓名/手机号</div>
          <el-input v-model.trim="page.keyword" class="ipt-sty" placeholder="请输入姓名/手机号"></el-input>
        </el-col>
        <el-col :span="6" class="t-left">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div"><span v-if="monthType=='留存月'" style="color: red">*</span>任务包名称</div>
          <el-select
            collapse-tags
            multiple
            filterable
            v-model="page.taskMainGuidList"
            placeholder="请选择任务包名称"
            class="ipt-sty"
            clearable
            @change="taskPackageChange"
          >
            <el-option
              v-for="(item, index) in taskPackageList"
              :key="index"
              :label="item.taskTitleOrganisation || item.taskTitleShort"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">项目任务名称</div>
          <el-select
            multiple
            collapse-tags
            v-model="page.taskDetailGuidList"
            placeholder="请选择项目任务名称"
            class="ipt-sty"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in taskContentName"
              :key="item.guid"
              :label="item.taskContentName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">合格状态</div>
          <el-select
            multiple
            collapse-tags
            size="mini"
            class="ipt-sty"
            v-model="page.approveStateList"
            filterable
            placeholder="请选择任务包状态"
          >
            <el-option
              v-for="item in approvalStateList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">操作状态</div>
          <el-select
            size="mini"
            class="ipt-sty"
            v-model="page.isCancel"
            clearable
            placeholder="请选择操作状态"
          >
            <el-option
              v-for="item in cancelList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">账单周期</div>
          <el-select size="mini" v-model="page.billCycle" style="flex: 1" placeholder="请选择" clearable filterable>
            <el-option v-for="item in cycleData" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button size="mini" type="info" @click="batchRepeal">批量撤销</el-button>
        <el-button size="mini" type="info" @click="batchRevert">批量还原</el-button>
      </div>
      <el-table
        :data="tableData"
        :height="tableHeight"
        tooltip-effect="light"
        stripe
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column fixed="left" label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" width="120" label="服务人员" header-align="center" align="left" fixed="left">
          <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="loginUser" width="120" label="账号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.loginUser || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          show-overflow-tooltip
          width="210"
          label="备案企业"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="accountMonth" width="120" label="月份" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.accountMonth || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTitle"
          show-overflow-tooltip
          width="180"
          label="任务包名称"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskContentName"
          width="180"
          label="项目任务名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
        </el-table-column>
        <el-table-column prop="approveState" width="120" label="合格状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveState | approveState }}</template>
        </el-table-column>
        <el-table-column prop="taskDetailCount" width="120" label="任务量" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskDetailCount || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          show-overflow-tooltip
          width="210"
          label="客户名称"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.customerName }}</template>
        </el-table-column>
        <el-table-column prop="taskTime" sortable width="140" label="业务时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="approvalTime" sortable width="140" label="审批时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approvalTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="cancelUpdateUserName" width="120" label="更新人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.cancelUpdateUserName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="cancelUpdateTime"
          sortable
          width="140"
          label="更新时间"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.cancelUpdateTime | getTime }}</template>
        </el-table-column>

        <el-table-column prop="bank" min-width="96px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" v-if="scope.row.isCancel === 'N'" @click="toRepeal(scope.row)">撤销</a>
            <a class="txt-color" v-if="scope.row.isCancel === 'Y'" @click="toRevert(scope.row)">还原</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  mixins:[getTenantDetail],
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      tableLoading: false,
      taskPackageList: [], // 任务包
      taskContentName: [], // 项目任务名称
      tenantList: [], // 备案药企
      multipleSelection: [], // 勾选项
      userGuid: userinfo.userGuid,
      staffGuid: userinfo.staffGuid,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      page: {
        // staffGuid: userinfo.staffGuid,
        accountMonth: '',
        tenantGuid: '',
        keyword: '',
        taskMainGuidList: [],
        taskDetailGuidList: [],
        approveStateList: [],
        isCancel: '',
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        billCycle:'',//账单周期
      },
      tableData: [],
      approvalStateList: [
        {
          name: '合格',
          value: 'Y',
        },
        {
          name: '不合格',
          value: 'N',
        },
        {
          name: '部分合格',
          value: 'P',
        },
      ],
      cancelList: [
        {
          name: '全部',
          value: '',
        },
        {
          name: '已撤销',
          value: 'Y',
        },
        {
          name: '未撤销',
          value: 'N',
        },
      ],
      monthType:'考核月',
      monthList:['考核月','留存月'],
      cycleData: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
    };
  },
  filters: {
    approveState(value) {
      if (!value) {
        return '-';
      }
      switch (value) {
        case 'Y':
          return '合格';
        case 'N':
          return '不合格';
        case 'P':
          return '部分合格';
      }
      return '-';
    },
  },
  async created() {
    this.getToday();
    await this.Mixins_getServiceProviderType();
    this.getTenantList(() => {
      this.getList();
      this.getTaskList();
    });
  },
  computed: {},
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    search() {
      if (this.monthType == '留存月'&&!this.page.taskMainGuidList.length) {
        return this.$message.error('请先选择任务包');
      }
      this.tableLoading = true;
      this.page.pageIndex = 1;
      let req = JSON.parse(JSON.stringify(this.page));
      (req.accountMonth = req.accountMonth ? req.accountMonth.replace('-', '') : '')
      if (this.monthType == '考核月') {
        req.accountMonth = req.accountMonth ? req.accountMonth.replace('-', '') : '';
      } else {
        req.belongAccountMonth = req.accountMonth ? req.accountMonth.replace('-', '') : '';
        delete req.accountMonth;
      }
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/platform-task/approve/list-valid-task`, req)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tableData = res.data.data && res.data.data.records ? res.data.data.records : [];
            this.page.totalPage = res.data.data ? res.data.data.totalPages : 0;
            this.page.totalRows = res.data.data ? res.data.data.totalRows : 0;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getList() {
      let req = JSON.parse(JSON.stringify(this.page));
      this.tableLoading = true;
      (req.accountMonth = req.accountMonth ? req.accountMonth.replace('-', '') : ''),
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/platform-task/approve/list-valid-task`, req)
          .then((res) => {
            this.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.tableData = res.data.data && res.data.data.records ? res.data.data.records : [];
              this.page.totalPage = res.data.data ? res.data.data.totalPages : 0;
              this.page.totalRows = res.data.data ? res.data.data.totalRows : 0;
            } else {
              this.$message.error(res.data.msg);
            }
          });
    },
    getToday() {
      let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      this.page.accountMonth = year + '-' + month;
    },
    emptySearch() {
      this.page = {
        tenantGuid: this.page.tenantGuid,
        // staffGuid: this.staffGuid,
        accountMonth: this.page.accountMonth,
        keyword: '',
        taskMainGuidList: [],
        taskDetailGuidList: [],
        approveStateList: [],
        isCancel: '',
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
      };
      this.monthType = '考核月'
      this.getList();
      this.getTaskPackageList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 撤销
    toRepeal(row) {
      this.$confirm('确定撤销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.fullscreenLoading = true;
          let param = [];
          param.push(row.guid);
          this.backValidTask(param);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    // 还原
    toRevert(row) {
      this.$confirm('确定还原吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.fullscreenLoading = true;
          let param = [];
          param.push(row.guid);
          this.restoreValidTask(param);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    // 批量撤销
    batchRepeal() {
      if (!this.haveSelect()) {
        return;
      }
      this.$confirm('确定撤销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.fullscreenLoading = true;
          let param = this.multipleSelection.filter(item=>item.isCancel === 'N').map((item) => item.guid);
          if (!param.length) {
            this.$message.warning('请勾选需要撤销的选项');
            this.fullscreenLoading = false;
            return
          }
          this.backValidTask(param);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    // 批量还原
    batchRevert() {
      if (!this.haveSelect()) {
        return;
      }
      this.$confirm('确定还原吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.fullscreenLoading = true;
          let param = this.multipleSelection.filter(item=>item.isCancel === 'Y').map((item) => item.guid);
          if (!param.length) {
            this.$message.warning('请勾选需要还原的选项');
            this.fullscreenLoading = false;
            return
          }
          this.restoreValidTask(param);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    restoreValidTask(param) {
      // 还原服务
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/platform-task/approve/restore-valid-task`, param)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            this.$message.success('还原成功');
            this.getList();
          } else {
            this.fullscreenLoading = false;
            this.$message.error(res.data.msg);
          }
        });
    },
    backValidTask(param) {
      // 撤销服务
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/platform-task/approve/back-valid-task`, param)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            this.$message.success('撤销成功');
            this.getList();
          } else {
            this.fullscreenLoading = false;
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取药企
    getTenantList(callBack) {
      let relType = '';
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        const serviceProviderTypeMap = {
          [ServiceProviderTypeEnum.THIRD_PARTY_SASS]: '13',
          [ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR]: '13',
          [ServiceProviderTypeEnum.GENERAL_CONTRACTOR]: '12',
        }
        relType = serviceProviderTypeMap[serviceProviderType]
      } catch (error) {
        console.log(error);
      }
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType,
      };
      this.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tenantList = res.data.data;
            console.log(1111111111,this.tenantList);
            if (this.tenantList && this.tenantList.length > 0 && !this.$route.query.tenantGuid) {
              this.page.tenantGuid = this.tenantList[0].sendTenantGuid;
              this.getTaskPackageList(); // #获取任务包
              if (callBack) callBack();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // todo 备案企业change
    tenantChange(val) {
      if (val) {
        this.page.taskMainGuidList = [];
        this.page.taskMainGuid = [];
        // this.getTaskList();
        this.getTaskPackageList(); // #获取任务包
      }
    },
    // todo 核算月下拉change
    accountMonthChange() {
      this.page.taskMainGuid = [];
      this.page.taskMainGuidList = [];
      // this.getTaskList();
      this.getTaskPackageList(); // #获取任务包
    },
    // todo 任务包change
    taskPackageChange() {
      this.getTaskList();
    },
    // todo根据企业\部门\核算月获取任务包列表 tenantGuid organisationGuid accountMonth
    getTaskPackageList() {
      let { page } = this;
      let param = JSON.parse(JSON.stringify(page));
      let query = {
        pageSize: -1,
        pageIndex: 1,
        tenantGuid: page.tenantGuid,
        state: ['已派发', '待上传', '待考核', '待结算', '已完结'],
        isExcludeDataPermission:true,
        // accountMonth: param.accountMonth ? param.accountMonth.replace('-', '') : '',
      };
      if(this.monthType=='考核月'){
        query.accountMonth = param.accountMonth ? param.accountMonth.replace('-', '') : '';
      }else{
        query.belongAccountMonth = param.accountMonth ? param.accountMonth.replace('-', '') : '';
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list-todo`, query).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.records) {
            let list = res.data.data.records;
            this.taskPackageList = Array.isArray(list) ? list.filter((item) => item.taskBelongCategory !== 3) : [];
          } else {
            this.taskPackageList = [];
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // todo 获取任务/菜单/平台名称
    getTaskList() {
      let query = JSON.parse(JSON.stringify(this.page));
      let req = query.taskMainGuidList;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/platform-task/approve/list-detail-task`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.page.taskDetailGuidList = [];
            this.taskContentName = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    haveSelect() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请勾选');
      }
      return this.multipleSelection.length;
    },
  },
};
</script>

<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.search-area-div {
  width: 86px;
  text-align: right;
  /* flex-shrink: 0; */
}
.ipt-sty {
  flex: 1;
}
.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.import-step-tip {
  color: #999;
  line-height: 25px;
  font-size: 12px;
}
.ipt-sty {
  flex: 1;
}
.el-col-6 {
  display: flex;
}
.w82{
  width: 82px;
}
</style>
